module.exports = __webpack_public_path__ + "static/media/19.4632f04c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/19.jpg
// module id = 552
// module chunks = 0